import React from "react";

import { cn } from "src/utils/cn";

export function ShellContentFrame({ children, className }) {
  return (
    <section className="min-w-0 flex-1">
      <div
        className={cn(
          "h-full overflow-hidden rounded-[20px] border border-gray-100 bg-white",
          className
        )}
      >
        <main className="h-full overflow-y-auto">{children}</main>
      </div>
    </section>
  );
}


